// extracted by mini-css-extract-plugin
module.exports = {"header":"ReferencesInfoResult_header__6HJGj","button":"ReferencesInfoResult_button__eht5L"};